import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SethContentRichTextComponent } from 'seth-content-rich-text';
import { FooterContent } from '../../models/content/footer-content.model';

@Component({
  selector: 'seth-footer',    
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {

 @Input() footerContent: FooterContent = {
    application: null,
    client: '',
    program: '',
    product: [],
    workflow: [],
    popupType: null,
    formName: '',
    programCode: '',
    dateRetrieved: new Date(),
  }

  public copyrightYear = '';
  public now: Date = new Date();

  getCopyrightYear(): string {
    const year = this.now.getFullYear();
    return year > 2025 ? `2025 - ${year}` : `${year}`;
  }

  ngOnInit(): void {
    this.copyrightYear = this.getCopyrightYear();
  }

}
